import { debounce } from 'lodash';
import { WOW } from 'wowjs';
import ScrollMagic from 'ScrollMagic';
// import 'chartjs-plugin-labels';
import 'chartjs-plugin-datalabels';
import map from '../map';
import newsletter from '../newsletter';
import isMaxWidth from '../util/isMaxWidth';
import stickybits from 'stickybits';

export default {
  initDropdown() {
    const $dropdownNavItem = $('.nav-item.dropdown');
    const $dropdownNavItemHref = $dropdownNavItem.children('a');

    if (!isMaxWidth(992)) {
      $dropdownNavItemHref.click(function() {
        location.href = this.href;
      });

      $dropdownNavItem.mouseover(function() {
        $(this)
          .find('.dropdown-menu')
          .addClass('show animated fadeIn faster');
      });

      $dropdownNavItem.mouseleave(function() {
        $(this)
          .find('.dropdown-menu')
          .removeClass('show animated fadeIn faster');
      });
    } else {
      $dropdownNavItem.unbind();
      $dropdownNavItemHref.unbind();
    }
  },
  initScrollMagic() {
    const controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 'onLeave',
        // duration: '100%', // this works just fine with duration 0 as well
        // However with large numbers (>20) of pinned sections display errors can occur so every section should be unpinned once it's covered by the next section.
        // Normally 100% would work for this, but here 200% is used, as Panel 3 is shown for more than 100% of scrollheight due to the pause.
      },
    });

    const slides = document.querySelectorAll('section.panel');

    // create scene for every slide
    for (var i = 0; i < slides.length; i++) {
      new ScrollMagic.Scene({
        triggerElement: slides[i],
        duration: '100%',
      })
        .setPin(slides[i], { pushFollowers: false })
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
  },
  affixSolutionSidebar() {
    $('.solution-sidebar').css(
      'width',
      $('.solution-sidebar')
        .parent()
        .width()
    );
    if (!isMaxWidth(992)) {
      const offsetAdminbar = $('#wpadminbar').outerHeight() || 0;
      const offsetHeader = $('.header').outerHeight();
      const offset = offsetAdminbar + offsetHeader + 24;

      stickybits('.solution-sidebar', { stickyBitStickyOffset: offset });

      $('.solution-sidebar').css('top', offset);
    }
  },
  affixSolutionNavbar() {
    const offsetHeader = $('.header').outerHeight() || 0;
    const offsetNavbar = $('#navbar-solution').outerHeight() || 0;

    $('#navbar-solution').css('top', offsetHeader);

    $('body').scrollspy({
      target: '#navbar-solution',
      offset: offsetHeader + offsetNavbar,
    });
  },

  init() {
    window.addEventListener(
      'resize',
      debounce(() => {
        this.affixSolutionSidebar();
        this.affixSolutionNavbar();
      }, 400)
    );

    $('.client-carousel').slick({
      mobileFirst: true,
      infinite: true,
      dots: false,
      rows: 1,
      slidesToShow: 3,
      slidesToScroll: 2,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: '<div class="slick-prev text-center"></div>',
      nextArrow: '<div class="slick-next text-center"></div>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 3,
            arrows: false,
          },
        },
      ],
    });

    $('#collapse-menu').on('show.bs.collapse', function() {
      const $hamburder = $('.hamburger');
      const $header = $('.header');
      const $navbar = $header.children('.navbar');

      $hamburder.addClass('is-active');

      if (
        $header.hasClass('header--heroup') &&
        !$header.hasClass('header--active')
      ) {
        $header.addClass('header--active');
        $navbar.removeClass('navbar-dark').addClass('navbar-light');
      }
    });

    $('#collapse-menu').on('hide.bs.collapse', function() {
      const $hamburder = $('.hamburger');

      $hamburder.removeClass('is-active');
    });

    $('#collapse-menu').on('hidden.bs.collapse', function() {
      const $header = $('.header');
      const $navbar = $header.children('.navbar');

      if (
        $header.hasClass('header--heroup') &&
        $header.hasClass('header--top')
      ) {
        $header.removeClass('header--active');
        $navbar.removeClass('navbar-light').addClass('navbar-dark');
      }
    });

    const wow = new WOW();

    window.addEventListener('load', () => {
      map.init();
      wow.init();
      this.initDropdown();
      this.affixSolutionSidebar();
      this.affixSolutionNavbar();
      this.initScrollMagic();

      $('#navbar-solution .nav-link').click(function(event) {
        event.preventDefault();
        const pageId = $(this).attr('href');
        // const offsetAdminbar = $('#wpadminbar').outerHeight() || 0;
        const offsetHeader = $('.header').outerHeight();
        const offsetNavbar = $('#navbar-solution').outerHeight() || 0;
        // const offset = offsetAdminbar + offsetHeader;
        $('html, body').animate(
          { scrollTop: $(pageId).offset().top - offsetHeader - offsetNavbar },
          1000
        );
      });
    });

    // let homeController = null;

    // window.addEventListener('load', () => {
    //   const initHomeMagic = () => {
    //     homeController = new ScrollMagic.Controller({
    //       globalSceneOptions: {
    //         triggerHook: 'onLeave',
    //       },
    //     });

    //     new ScrollMagic.Scene({
    //       triggerElement: '.hero',
    //       duration: $('.hero').outerHeight() / 2,
    //       offset: $('.hero').outerHeight() / 2,
    //     })
    //       // .addIndicators({ name: '1' })
    //       .addTo(homeController)
    //       .on('progress', function(e) {
    //         var newpercent = e.progress;
    //         let newspace = newpercent;
    //         if (newspace * 200 < 140) {
    //           $('.media-solution--first').css(
    //             'margin-top',
    //             newspace * 200 + 'px'
    //           );
    //         }
    //         if (newspace * 100 <= 64) {
    //           $('.media-solution--second').css(
    //             'margin-top',
    //             newspace * 100 + 'px'
    //           );
    //         }

    //         // }
    //       });
    //   };

    //   if (!isMaxWidth(992)) {
    //     initHomeMagic();
    //   }

    //   window.addEventListener(
    //     'resize',
    //     debounce(() => {
    //       this.initDropdown();
    //       if (isMaxWidth(992)) {
    //         if (homeController) {
    //           $('.media-solution').css('margin-top', 0);
    //           homeController = homeController.destroy(null);
    //         }
    //       } else {
    //         if (homeController) {
    //           homeController = homeController.destroy(null);
    //         }
    //         initHomeMagic();
    //       }
    //       this.affixSolutionSidebar();
    //     }, 400)
    //   );
    // });

    window.addEventListener('load', () => {
      window.addEventListener(
        'resize',
        debounce(() => {
          this.initDropdown();
          this.affixSolutionSidebar();
        }, 400)
      );
    });

    window.addEventListener('load', () => {
      newsletter.init();

      // const controller = new ScrollMagic.Controller({ addIndicators: false });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js